<template>
  <div
    class="bb-popup-info-tags"
    :style="position"
  >
    {{description}}
  </div>
</template>

<script>
export default {
  name: 'PopupInfoTags',
  props: {
    position: {
      type: Object,
      default: () => ({})
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bb-popup-info-tags {
    position: absolute;
    left: -15px;
    top: -27px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 9px 10px 9px 10px;
    background: $color-white;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    border-radius: 5px;
    z-index: 20;
    pointer-events: none;
    width: max-content;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.12);

    &:before {
      content: '';
      position: absolute;
      left: 10px;
      bottom: -3px;
      display: block;
      width: 0;
      height: 0;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      border-top: 3px solid $color-white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Tags/PopupInfoTags/PopupInfoTags.vue